<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="width:100%">
            <div style="display: flex">
                <el-button @click="downFile" type="success" plain size="mini">{{$t('getapi[2762]')}}<i class="el-icon-download el-icon--right"></i>
                </el-button>
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadurl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :file-list="fileList"
                        :limit="1"
                        style="margin-left: 8px;width:150px"
                >
                    <el-button type="primary" plain size="mini">{{$t('getapi[7478]')}}<i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                </el-upload>
                <el-button type="primary" size="mini" @click="removeT">{{$t('getapi[7423]')}}</el-button>
                <el-button type="primary" size="mini" @click="clearT">{{$t('getapi[7424]')}}</el-button>
                <el-button type="primary" size="mini" @click="doVerify">{{$t('getapi[1777]')}}</el-button>
                <el-button type="primary" size="mini" @click="doCloseWIP" :disabled="!btn.canDoCloseWIP">{{$t('getapi[7476]')}}</el-button>
            </div>
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[1974]') }}</td>
                    <td style="width:150px;">
                        <el-input v-model="dataDetail.cboyear" type="text" size="mini"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[410]') }}</td>
                    <td style="width:150px;">
                        <el-input v-model="dataDetail.create_person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[550]') }}</td>
                    <td style="width:150px;">
                        <el-input v-model="dataDetail.audit_person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                    </td>
                    <td style="width:60px">{{$t('getapi[7477]')}}</td>
                    <td style="width:150px;">
                        <el-input v-model="dataDetail.sum" type="text" size="mini" :readonly="true" class="readO"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[1975]') }}</td>
                    <td>
                        <el-select filterable v-model="dataDetail.cbomonth"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                    <td>{{ $t('getapi[135]') }}</td>
                    <td>
                        <el-input v-model="dataDetail.create_time" type="text" size="mini" :readonly="true" class="readO"></el-input>
                    </td>
                    <td>{{ $t('getapi[4044]') }}</td>
                    <td>
                        <el-input v-model="dataDetail.audit_time" type="text" size="mini" :readonly="true" class="readO"></el-input>
                    </td>
                </tr>
            </table>
            <div id="xpane-0">
                <vxe-table :data="datajson.Lists" size="mini" :loading="loading" header-cell-class-name="headerclass"
                           :height="tableHeight"
                           @row-click="selectrow"
                           :highlight-current-row="true"
                           stripe
                           border
                           resizable
                           ref="singleTable">
                    <vxe-table-column  show-footer-overflow v-for="item in datajson.TbHeader"
                                       :key="item.Headen"
                                       :field="item.Headen"
                                       :title="item.Headcn"
                                       width="120px"
                    ></vxe-table-column>
                </vxe-table>
            </div>
        </div>

        <el-dialog v-dialogDrag :visible.sync="isShowSelectSheet" width="25%" :close-on-click-modal="false">
            <el-table
                    :data="dataSelectSheet"
                    ref="sheetTable"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    @row-click="changeItem_code"
                    @selection-change="handleSelectionChange"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[6388]')"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowSelectSheet = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="getNoBalanceData" :disabled="selectNameData.length != 1">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_nobalancelock',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-200
            }
        },
        data() {
            return {
                userData: [], // 用户信息
                DbTbNames: '',
                loading: false, // 主表加载状态
                dataDetail:{
                    cboyear: '',
                    cbomonth: '',
                    sum: ''
                },
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                yearList: [],
                uploadurl: '',
                datajson: [],
                returnArray:[],
                returnURL:'',
                excelURL:'',
                fileList: [],
                isShowSelectSheet: false, // 是否显示选择sheet弹窗
                dataSelectSheet: [], //
                selectNameData: [], // 选择的sheet
                selectIndex: '', //选中行下标
                btn:{
                    canDoCloseWIP: false
                },
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Fin/Wip/BalanceLockImportUpFile?token=' + token;
        },
        watch: {
            'datajson.Lists': function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.dataDetail.cboyear = new Date().getFullYear()
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6670]"),this.$t("getapi[6633]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    that.returnURL = res.DataContent.URL;
                    let arr = res.DataContent.SheetList
                    if(arr.length > 0){
                        that.dataSelectSheet = []
                        for(let i=0;i<arr.length;i++){
                            that.dataSelectSheet = [...that.dataSelectSheet,{
                                name: arr[i]
                            }]
                        }
                        that.isShowSelectSheet = true
                    }
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            downFile(){
                let that = this
                that.$http.urlpost('/Fin/Wip/GetNoBalanceLockImportTemplat', '', function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            getNoBalanceData(){
                let that = this
                let parm = {
                    filepath: that.returnURL,
                    sheetname: that.selectNameData[0]
                }
                that.$http.urlpost('/Fin/Wip/GetNoBalanceLockData', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent
                        that.isShowSelectSheet = false
                        that.btn.canDoCloseWIP = false
                    }
                });
            },
            changeItem_code(row) {
                let that = this
                that.$refs.sheetTable.toggleRowSelection(row);
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this
                console.log(val)
                that.selectNameData = []
                for(let i = 0;i<val.length;i++){
                    that.selectNameData.push(val[i].name)
                }
            },
            // 执行检验
            doVerify(){
                let that = this
                that.loading = true;
                let parm = {
                    cboyear: that.dataDetail.cboyear,
                    cbomonth: that.dataDetail.cbomonth,
                    filepath: that.datajson.URL,
                    Lists: that.datajson.Lists,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Fin/Wip/GetNoBalanceLockDataVerify', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.btn.canDoCloseWIP = true
                    } else if(res.Success == 2){
                        that.$message.warning(that.$processdata.explainCallbackMsg(res.Msg))
                        that.datajson = res.DataContent
                    }

                    that.loading = false;
                });
            },
            // 执行标定
            doCloseWIP(){
                let that = this
                let parm = {
                    cboyear: that.dataDetail.cboyear,
                    cbomonth: that.dataDetail.cbomonth,
                    filepath: that.datajson.URL,
                    Lists: that.datajson.Lists
                }
                that.$http.urlpost('/Fin/Wip/GetNoBalanceLockDoCloseWIP', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.dataDetail.sum = res.UniqueNum
                    }
                });
            },
            selectrow(row){
                let that = this;
                that.selectIndex = row.index;
            },
            removeT(){
                let that = this
                that.datajson.Lists.splice(that.selectIndex,1)
            },
            clearT(){
                let that = this
                that.datajson.Lists = []
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
